const DEV_BACKEND_ORIGIN = 'http://127.0.0.1:12067';

function isLocalDev() {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
}

function withBackendOrigin(path: string) {
  return isLocalDev() ? `${DEV_BACKEND_ORIGIN}${path}` : path;
}

/**
 * Resolve backend asset URL for manager app.
 *
 * Rules:
 * - Empty/undefined → empty string
 * - Already absolute http(s), data:, blob: → return as is
 * - Already proxied "/api/..." → return as is
 * - Leading "/static", "/upload", "/uploads" → prefix with "/api"
 * - Bare "static/...", "upload/...", "uploads/..." → prefix with "/api/"
 */
export function resolveBackendResourceUrl(path?: string): string {
  if (!path) return '';
  const s = String(path).trim();
  if (!s) return '';

  // data/blob/absolute URLs
  if (/^(data:|blob:)/i.test(s)) return s;
  if (/^https?:\/\//i.test(s)) return s;

  // already proxied through /api
  if (s.startsWith('/api/')) return withBackendOrigin(s);

  // normalize leading slash
  if (s.startsWith('/static/') || s.startsWith('/upload/') || s.startsWith('/uploads/')) {
    return withBackendOrigin(`/api${s}`);
  }

  // bare segment
  if (s.startsWith('static/') || s.startsWith('upload/') || s.startsWith('uploads/')) {
    return withBackendOrigin(`/api/${s}`);
  }

  // fallback: keep as is
  return s;
}

export default resolveBackendResourceUrl;
